import React, { useRef, useState, useEffect } from 'react'
import { Box } from '@chatterbug/aaron'
import {
  PAGE_VERTICAL_PADDING,
  MAX_WIDTHS_FOR_BREAKPOINTS,
} from 'src/ui/PageLayout/PageLayout'

const CONTAINER_STYLES = {
  mx: 'auto',
  maxWidth: MAX_WIDTHS_FOR_BREAKPOINTS,
}

const PageStickyHeader = ({ children }) => {
  const headerRef = useRef()
  const [position, setPosition] = useState()

  useEffect(() => {
    const handlePosition = () => {
      const rect = headerRef.current.getBoundingClientRect()
      setPosition(rect.height)
    }
    handlePosition()
    window.addEventListener('resize', handlePosition)
    return () => window.removeEventListener('resize', handlePosition)
  }, [children])

  return (
    <>
      <Box
        boxShadow={{ _: 'pressed', tabletWide: 'none' }}
        sx={{ position: 'sticky', top: 0, zIndex: 3 }}
      >
        <Box
          ref={headerRef}
          bg={{ _: 'white100', tabletWide: '#fafafa' }}
          pt={{ _: '1x', tabletWide: PAGE_VERTICAL_PADDING }}
          pb={{ _: '1x', tabletWide: '2x' }}
          px={{ _: '2x', tablet: '3x' }}
          {...CONTAINER_STYLES}
        >
          {children}
        </Box>
      </Box>
      <Box
        display={{ _: 'none', tabletWide: 'block' }}
        sx={{
          position: 'sticky',
          top: `${position}px`,
          zIndex: 1,
        }}
      >
        <Box {...CONTAINER_STYLES}>
          <Box bg="gray88" height={1} />
        </Box>
      </Box>
      <Box
        display={{ _: 'none', tabletWide: 'block' }}
        {...CONTAINER_STYLES}
        sx={{ position: 'relative' }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: '-2px',
            height: '4px',
            width: '100%',
            backgroundColor: 'gray99',
            zIndex: 2,
          }}
        />
      </Box>
    </>
  )
}

export default PageStickyHeader
